import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  icon:string,
  textIcon:string,
  title:string,
  text:string,
  textLink:string,
  firstBtnText:string,
  secondBtnText:string
}

@Component({
  selector: 'app-modal-location',
  templateUrl: './modal-location.component.html',
  styleUrls: ['./modal-location.component.scss']
})
export class ModalLocationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalLocationComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
  }
}
